require('./CustomerCreateEditPage');
require('./CustomerShowPage');
require('./JobCreateEditPage');
require('./JobSurveyPage');
require('./JobProductPage');
require('./JobQuotePage');
require('./JobOrderPage');
require('./JobOrderDeliveryPage');
require('./JobOrderInstallationPage');
require('./JobOrderInvoicePage');
require('./SiteCreateEditPage');
require('./CalendarPage');
require('./Dashboard');
require('./CompanySettingsPage');